import React from "react";
import { ImgFileDoc } from "./Images/ImgFileDoc.tsx";
import { ImgFileDocx } from "./Images/ImgFileDocx.tsx";
import { ImgFilePdf } from "./Images/ImgFilePdf.tsx";
import { ImgFileTxt } from "./Images/ImgFileTxt.tsx";
import { ImgFileCsv } from "./Images/ImgFileCsv.tsx";
import { ImgFileHtml } from "./Images/ImgFileHtml.tsx";
import { ImgFileSvg } from "./Images/ImgFileSvg.tsx";
import { ImgFileSql } from "./Images/ImgFileSql.tsx";
import { ImgFileLog } from "./Images/ImgFIleLog.tsx";
import { ImgFileGeneric } from "./Images/ImgFileGeneric.tsx";

export function resolveIconComponent(iconType: string): React.ComponentType<{ size?: number }> {
  switch (iconType) {
    case 'pdf': return ImgFilePdf;
    case 'doc': return ImgFileDoc;
    case 'docx': return ImgFileDocx;
    case 'txt': return ImgFileTxt;
    case 'csv': return ImgFileCsv;
    case 'html': return ImgFileHtml;
    case 'svg': return ImgFileSvg;
    case 'sql': return ImgFileSql;
    case 'log': return ImgFileLog;
    default: return ImgFileGeneric;
  }
}
